// @core/api/endpoints/calendar/list_calendar_policies.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListCalendarPoliciesResponse,
} from '../../../types/calendar';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/calendar';

/**
 * List calendar policies
 * Returns calendar policies, optionally filtered by scope entity type.
 */
export async function ListCalendarPolicies(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListCalendarPoliciesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/calendar-policies`;
  const requestOptions = options;
  return client.get<ListCalendarPoliciesResponse>(requestPath, { ...requestOptions, params });
}
